// removed by extract-text-webpack-plugin
module.exports = {"root":"ImageFromFile__root__2Sg5n","threeToTwoWrapper":"ImageFromFile__threeToTwoWrapper__1I3Ag","aspectWrapper":"ImageFromFile__aspectWrapper__27CF6","rootForImage":"ImageFromFile__rootForImage__37fTx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageFromFile/ImageFromFile.css
// module id = 1862
// module chunks = 0